import React from 'react';

const CheckIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none" stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
    >
        <path d="M20 6 9 17l-5-5"/>
    </svg>
);

export default CheckIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/CheckIcon.jsx